import { useRuntimeConfig } from "#imports";
import { renderBlocks } from "#strapi-blocks-renderer/utils";
export const useBlocksText = (blockNodes) => {
  const prefix = useRuntimeConfig().public.strapiBlocksRenderer.blocksPrefix;
  const textNodes = renderBlocks(blockNodes, prefix);
  return {
    text: textNodes
  };
};
